import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
// import storage from "redux-persist/lib/storage/session";
import storage from "redux-persist/lib/storage";
import counterReducer from "./Counter/counter.reducer";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["count"],
};

const rootReducer = combineReducers({
  count: counterReducer,
});

export default persistReducer(persistConfig, rootReducer);
